import { useState } from "react";
import { ButtonGroup, ButtonGroupItem } from "../common/Forms";
import VerificationInput from "./VerificationInput";

const VerifyForm = ({ id, handleSkip, afterSave }) => {
  const VERIFY_TYPES = ["tel", "email"];
  const [data, setData] = useState("");
  const [type, setType] = useState(VERIFY_TYPES[0]);

  const handleType = (e) => {
    setType(e.target.id);
  };

  return (
    <div className="card-body">
      <div className="form-control">
        <ButtonGroup>
          <ButtonGroupItem
            id="tel"
            active={type === "tel"}
            onClick={handleType}
          >
            휴대전화
          </ButtonGroupItem>
          <ButtonGroupItem
            id="email"
            active={type === "email"}
            onClick={handleType}
          >
            이메일
          </ButtonGroupItem>
        </ButtonGroup>
      </div>
      <VerificationInput {...{ id, type, data, setData, afterSave }} />
      <div className="form-control mt-6">
        <hr />
        <button
          className="btn btn-ghost btn-sm p-0 mt-3 text-accent"
          onClick={handleSkip}
        >
          다음에 입력하기
        </button>
      </div>
    </div>
  );
};

export default VerifyForm;
